export const projectCategories = [
  {
    id: '1',
    name: { ka: 'საქართველოს განათლებისა და მეცნიერების სამინისტრო', en: '', },
  },
  {
    id: '2',
    name: { ka: 'NATO', en: 'NATO', },
  },
  {
    id: '3',
    name: { ka: 'ევროკომისია', en: '', },
  },
  {
    id: '4',
    name: { ka: 'ღია საზოგადოების ფონდი', en: '', },
  },
]

export const projectItems = [
  {
    id: '',
    name: { ka: 'საქართველოს ერთიანი საგანმანათლებლო ინფორმაციულ-საკომუნიკაციო ქსელის მართვა.', en: '', },
    year: '2007',
    category: '1',
  },
  {
    id: '',
    name: { ka: 'საჯარო სკოლების ICT მენეჯერებისათვის ტრენინგების ჩატარება ოპერაციული სისტემა Linux-ის ადმინისტრირებისა და ტექნიკური მხარდაჭერის საკითხში.', en: '', },
    year: '2008',
    category: '1',
  },
  {
    id: '',
    name: {
      ka: 'ქსელური ინფრასტრუქტურის გრანტი "საქართველოს სამეცნიერო-საგანმანათლებლო კომპიუტერული ქსელების ასოციაცია - გრენას ქსელური ინფრასტუქტურის განვითარება".',
      en: 'Networking Infrastructure Grant "Development of Network Infrastructure of Georgian Research and Educational Networking Association (GRENA)".',
    },
    year: '1999',
    category: '2',
  },
  {
    id: '',
    name: {
      ka: 'ქსელური ინფრასტრუქტურის გრანტი "საქართველოს სამეცნიერო-საგანმანათლებლო კომპიუტერული ქსელების ასოციაცია გრენას ინფრასტრუქტურის განვითარება".2003 ქსელური ინფრასტრუქტურის გრანტი “საქართველოს საშუალო სკოლების ინტერნეტით უზრუნველყოფა”.',
      en: 'Networking Infrastructure Grant "Development of Networking Infrastructure of the Georgian Research and Educational Networking Association (GRENA)".',
    },
    year: '2002',
    category: '2',
  },
  {
    id: '',
    name: { ka: 'ჰორიზონტ 2020 პროგრამა "ეროვნული ინიციატივები ღია მეცნიერებისათვის ევროპაში (NI4OS-ევროპა)"', en: '', },
    year: '2019',
    category: '3',
  },
  {
    id: '',
    name: { ka: 'ENPI „EU4Digital: სამეცნიერო და საგანმანათლებლო საზოგადოებების დაკავშირება (EaPConnct2)“', en: '', },
    year: '2020',
    category: '3',
  },
  {
    id: '',
    name: { ka: 'ჰორიზონტ 2020 პროგრამა "EGI-ACE: თანამედროვე გამოთვლები EOSC-ისათვის (EGI-ACE)"', en: '', },
    year: '2021',
    category: '3',
  },
  {
    id: '',
    name: { ka: 'GÉANT ჰორიზონტი ევროპა GN5-1 (GN5-1)', en: '', },
    year: '2023',
    category: '3',
  },
  {
    id: '',
    name: { ka: 'ინტერნეტის პროგრამის გრანტი "საქართველოს სამეცნიერო-საგანმანათლებლო კომპიუტერული ქსელების ასოციაცია - გრენას მაღალი ენერგიების ფიზიკის ინსტიტუტისა და გამოთვლითი მათემატიკის ინსტიტუტის ინტერნეტის ცენტრების მომსახურება".', en: '', },
    year: '2000',
    category: '4',
  },
  {
    id: '',
    name: { ka: '“ახალი სასწავლო პროგრამების, კურსების და სერვისების დანერგვა საინფორმაციო ტექნოლოგიების სფეროში”.', en: '', },
    year: '2013',
    category: '4',
  },
]

export const projectsOngoingItems = [
  {
    id: '',
    title: { ka: 'ევროკომისიის ჰორიზონტ 2020 პროგრამა', en: 'European Commission HORIZON 2020 Programme', },
    project_name: { ka: 'EGI-ACE: თანამედროვე გამოთვლები EOSC-ისათვის', en: 'EGI-ACE: Advanced Computing for EOSC', },
    start_date: '2021-01-001',
    end_date: '2023-06-30',
    contract: '101017567',
    image_url: '',
    description: {
      ka: 'EGI-ACE პროექტის ძირითად მიზანს წარმოადგენს ევროპის ღია მეცნიერების Cloud-ის გამოთვლითი პლატფორმის დანერგვა და EOSC Data Commons–ის განვითარებაში წვლილს შეტანა ინტეგრირებული გამოთვლითი პლატფორმების, მონაცემთა სივრცისა და საშუალებების მიწოდებით, რომელიც შესაბამისობაშია ევროპის ძირითად Cloud პროექტებთან და HPC–ს ინიციატივებთან.<br />პროგრამის კონკრეტული მიზნები შემდეგია:<br />• EOSC გამოთვლითი პლატფორმის შეთავაზება და მიწოდების არეალის გაფართოება;<br />• წვლილი შეიტანოს ევროკავშირის მონაცემთა სტრატეგიისა და EOSC Data Commons-ის განხორციელებაში მწვანე გარიგების (green deal), ჯანმრთელობის, ფუნდამენტური კვლევებისა და სოციალურ-ჰუმანიტარულ მეცნიერებათა მხარდაჭერის მიზნით;<br />• მოახდინოს EOSC გამოთვლითი პლატფორმის ინტეგრირება EOSC პორტალთან და EOSC ბირთვთან;<br />• წვლილი შეიტანოს გლობალური ღია სამეცნიერო Cloud-ის რეალიზებაში;<br />• მოახდინოს EOSC–ზე მოთხოვნის ზრდა სხვადასხვა სექტორებსა და დისციპლინებში.',
      en: 'EGI-ACE’s main goal is to implement the compute platform of the European Open Science Cloud and contribute to the EOSC Data Commons by delivering integrated computing platforms, data spaces and tools as an integrated solution that is aligned with major European cloud federation projects and HPC initiatives.',
    },
  },
  {
    id: '',
    title: { ka: 'ევროკავშირის საგარეო ღონისძიებები', en: '', },
    project_name: { ka: 'EU4Digital: სამეცნიერო და საგანმანათლებლო საზოგადოებების დაკავშირება (EaPConnct)', en: '', },
    start_date: '2020-07-01',
    end_date: '2025-06-30',
    contract: 'ENI/2019/407-452',
    image_url: '',
    description: { ka: 'პროექტის ძირითადი მიზანია სამეცნიერო და საგანმანათლებლო საზოგადოებების დაკავშირება ევროპისა და აღმოსავლეთ პარტნიორობის ქვეყნებს შორის და ციფრული უთანასწორობის შემცირება.<br />პროექტის სპეციფიკური მიზნები შემდეგია:<br />• ქსელური ინფრასტრუქტურის გაფართოება (ციფრული მაგისტრალი) ქვეყნებს შორის სამეცნიერო ინფორმაციის გაცვლის უზრუნველსაყოფად.<br />• EaPConnect პროექტის ფარგლებში დანერგილი სერვისების მოხმარების გაფართოება და ახალი სერვისების შეთავაზება მეცნიერებისა და განათლების სფეროში საერთაშორისო თანამშრომლობის გაღრმავებისათვის.<br />• EaP NREN-ების პოზიციის გამყარება ნაციონალურ სამეცნიერო-საგანმანათლებლო ეკოსისტემაში.', en: '', },
  },
  {
    id: '',
    title: { ka: 'ევროკომისიის ჰორიზონტი ევროპის პროგრამა', en: '', },
    project_name: { ka: 'GÉANT ჰორიზონტი ევროპა GN5-1 (GN5-1)', en: '', },
    start_date: '2023-01-01',
    end_date: '2024-12-31',
    contract: '',
    image_url: '',
    description: { ka: 'GN5-1 მიზნად ისახავს უზრუნველყოს უფრო სწრაფი, უფრო მდგრადი და უსაფრთხო კავშირის ინფრასტრუქტურა და კოლობორაციის სერვისები, რათა მკვლევარებმა და სტუდენტებმა მიიღონ წვდომა აპლიკაციებზე, რომლებიც მხარს უჭერს მტკიცებულებებზე დაფუძნებულ და ეფექტურ თანამშრომლობას ვირტუალურ კვლევით გუნდებში, მთელი მსოფლიოს მასშტაბით. GN5-1 გააგრძელებს უახლესი, ეკონომიური, უსაფრთხო და მგრადი კავშირის განვითარებას, რათა უზრუნველყოს შეუზღუდავი კავშირის სიჩქარე ევროპის და NREN-ების ქსელებში. GN5-1 უზრუნველყოფს ინოვაციურ და სანდო იდენტიფიკაციის ინფრასტრუქტურას და სერვისებს, რათა მიაღწიოს T&I სერვისების სტრატეგიულ პოზიციონირებას, როგორც კვლევისა და განათლების თანამშრომლობის ძირითად ხელშემწყობს ევროპაში. GN5-1 უზრუნველყოფს მკვლევარებისა და სტუდენტებისთვის ღია მეცნიერებისათვის საჭირო ღირებულ სერვისებზე წვდომას.', en: '', },
  },
]